import { saveSteamUserInfoEndpoint, } from 'root/src/shared/steam/endpoints/saveSteamUserInfo.endpoint';
export const steamEndpoints = Object.assign({}, saveSteamUserInfoEndpoint);
